module.exports = __webpack_public_path__ + "static/lettuce-grow-urban-farming.372f14c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lettuce-grow-urban-farming.png
// module id = 117
// module chunks = 35783957827783 263791100135453